<template>
    <div class="form-content ve-list">
		<div class="collapse-title" :style="{backgroundColor: selectColor}" @click="closeContent">
			<span class="collapse-title-span">{{localized(`label`)}}</span>
			<el-popover
				placement="bottom"
				width="60"
				:ref="'popover-' + popoverKey"
				v-model="popoverShow"
				trigger="hover">
				<div slot="reference" @click.stop="handleClick" :style="{backgroundColor: selectColor}" class="popover-title-wrap">
					<div class="change-color-btn"></div>
					<i class="el-icon-arrow-right" style="opacity: .5"></i>
				</div>
				<template> 
					<div class="color-options">
						<div v-for="(element, index) in options" :key="index" class="color-wrap">
							<div v-if="index==options.length-1" :style="{backgroundColor: element, flex: '1', height: '40px', border: 'none',textAlign:'center'}" @click="changeCC(element)">
								clean
							</div>
							<div v-else :style="{backgroundColor: element, width: '100%', height: '100%', border: 'none'}" @click="changeCC(element)"></div>
						</div> 
					</div>
					
				</template>
			</el-popover>
		</div>
		<el-collapse-transition>
			<div v-show="showContent">
				<el-form :model="itemdata" :ref="`form[${item.uuid}]`" label-position="left" class="other-object" :style="{borderColor: borderColor}" @showValidFail="showValidFailed" >
					<form-items v-model="itemdata" :items="items" :editable="editable" :editStatus='editStatus'/>
				</el-form>
			</div>
			
		</el-collapse-transition>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'
import FormItems from '../FormItems'
import language from '@/lang'
import utils from '../../utils'
import callApp from '@/services/sdk'

export default {
	name: 'list-widget',
  data() {
		return {
			copyitem: {},
			options: ["#26ccd8",
						"#5f45ff",
						"#47aee3",
						"#d5d6d8",
						"#96d7f9",
						"#f9e264",
						"#f47a75",
						"#50c48f",
						"#ffffff"],
		selectColor: '',
		tempColor: '',
		borderColor: '#ccc',
		popoverKey: '',
		showContent: false,
		popoverShow: false,
		clickPopoverShow: false,
		items: []
    }
  },
	props: {
		editable: { type: Boolean },
		item: Object,
		value: Object,
	deep: Number,
	editStatus: { type: String }
	},
	components: { FormItems },
	beforeDestroy() {
		// alert('destroy')
	},
	methods: {
		closeContent() {
			this.showContent = !this.showContent
		},
		addListItem() {
			this.itemdata.push(this.copyitem)
      this.$nextTick(() => {
				let result = this.$store.getters.getFormSet.slice().filter(item => item !== undefined)
				let name = `form[${this.item.uuid}/${this.itemdata.length - 1}]`
				this.$refs[name] && result.push(this.$refs[name][0])
				this.$store.dispatch('setFormSet', result)
      })
		},
		handleClick(e) {
			this.clickPopoverShow = !this.clickPopoverShow
			this.popoverShow = this.clickPopoverShow
		},
		changeCC(element) {
			this.selectColor = element
			this.borderColor = (this.selectColor == '' || this.selectColor == '#ffffff') ? '#ccc' : this.selectColor
			this.popoverShow = false
			this.clickPopoverShow = false
			callApp('setOtherObjectColor', {
								type: 'storage.updateOtherObjectColor',
								data: {
									key: this.item.name,
									val: element
								}
							}, 'cbSetOtherObjectColor')
		},
		removeListItem(idx) {
			this.itemdata.splice(idx, 1)
			let result = this.$store.getters.getFormSet.slice().filter(item => item !== undefined)
			let name = `form[${this.item.uuid}/${idx}]`
      let delIndex
			result.forEach((form, index) => {
				if (form === name) {
					delIndex = index
        }
      })

			result.splice(delIndex, 1)
			this.$store.dispatch('setFormSet', result)
		},
		deepClone(obj) {
			let result = Array.isArray(obj) ? [] : {}
			for (let key in obj) {
				if (obj.hasOwnProperty(key)) {
					if (typeof obj[key] === 'object') {
						result[key] = this.deepClone(obj[key]) //递归复制
					} else {
						result[key] = ''
					}
				}
			}
			return result;
		},
			localized(key){
				return language.localize(this.$store.state,this.item.name, key, this.item[key])
			},
			handleChange(val) {
				console.log('val:', val)
			},
			showValidFailed() {
				
				this.showContent = true
				this.selectColor = this.selectColor.length > 0 ? this.selectColor : "#ffffff"
				var tColor = JSON.parse(JSON.stringify(this.selectColor))
				this.selectColor = "red"
				var that = this
				setTimeout(function(){
					that.selectColor = tColor
				},3000);
			}
	},
	computed: {
		...mapGetters({
			formStatus: 'getFormStatus',
			softDataStatus: 'getSoftDataStatus'
		}),
		disabled() {
			return this.softDataStatus === 'disable'
		},
		itemdata: {
			get() { return this.value },
			set(itemdata) { 
				this.showWarning = false
				this.$emit('input', itemdata) }
		}
	},
	created() {
		var now = new Date();
		this.popoverKey = now.getTime();
	},
  mounted() {

		this.items = this.item.content
		let result = this.$store.getters.getFormSet.slice().filter(item => item !== undefined)
		let name = `form[${this.item.uuid}]`

		this.$refs[name] && result.push(this.$refs[name])
		this.$store.dispatch('setFormSet', result)


	    this.item.name && callApp('getOtherObjectColor', {
								type: 'storage.getOtherObjectColor',
								data: {key: this.item.name}
		}, 'cbGetOtherObjectColor').then(data => {
			this.selectColor = data
			this.borderColor = (this.selectColor == '' || this.selectColor == '#ffffff') ? '#ccc' : this.selectColor
		})
  }

}
</script>

<style scoped>
  .ve-list > span {
    font-weight: 600;
	color: #000000;
	line-height: 32px;
  }
  .collapse-title-span {
	font-weight: 600;
	text-shadow: 0 0 1px #fff;
	color: #333;
	/* line-height: 20px; */
  }
  .collapse-title-warning {
	font-weight: 600;
	text-shadow: 0 0 1px #fff;
	color: #aa0000;

  }

	.other-object {
		border: 1px solid #ccc;
		border-radius: 3px;
		padding: 10px;
	}
	.collapse-title {
		/* width: 100%; */
		display: flex;
		/* min-height: 50px; */
		justify-content: space-between;
		align-items: center;
		margin: 10px 0;
		padding: 10px;
	}
	.color-options {
		display: flex;
		width: 150px;
		height: 185px;
		flex-wrap: wrap;
		/* justify-content: flex-start; */
	}
	.color-wrap {
		/* flex: 1; */
		width: calc(calc(100% / 3) - 10px);
		margin:2px 5px;
		height:50px;
		box-sizing: border-box;

	}
	.change-color-btn {
		border: 1px solid #ccc;
		border-radius: 20px;
		width: 40px;
		height: 40px;
		box-sizing: border-box;
		background: linear-gradient(cyan, transparent),
		linear-gradient(-45deg, magenta, transparent),
		linear-gradient(45deg, yellow, transparent);
		/* margin-top: 4px; */
		/* margin-right: 4px; */

		/* margin: 10px 0; */
	}
	.popover-title-wrap {
		display: flex;
		align-items: center;
	}

</style>
